// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Dt8n","col":"styles_col__3ykaS"};